function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, makeStyles } from '@applyboard/ui-components';
import { setField } from "../../../../store/Actions/Actions";
import ErrorMessage from "../ErrorMessage";
import { Keys } from "../Constants";
import { initialState as initialAppState } from "../../../../store/Reducers/CefApplicationReducer";
import { getApplication } from "../../../../store/Selectors";
import LabelWrapper from "../LabelWrapper";
import TestScores from "./TestScores";
import { VisitorStudentLanguage } from "../../Utilities/LanguageHelper";
var initialUncheckedGmatState = _objectSpread({}, initialAppState.application.gmatTest);
var initialCheckedGmatState = {
  value: true,
  t: '',
  tp: '',
  v: '',
  vp: '',
  q: '',
  qp: '',
  w: '',
  wp: ''
};
var initialUncheckedGreState = _objectSpread({}, initialAppState.application.greTest);
var initialCheckedGreState = {
  value: true,
  v: '',
  vp: '',
  q: '',
  qp: '',
  w: '',
  wp: ''
};
var useStyles = makeStyles({
  error: {
    marginBottom: '22px'
  }
});
var initialState = {
  gmat: false,
  gre: false,
  dont_have: false
};
var StandardizedTests = function StandardizedTests(props) {
  var error = props.error,
    validationError = props.validationError,
    clearError = props.clearError,
    showError = props.showError,
    standardizedTests = props.standardizedTests,
    greTest = props.greTest,
    gmatTest = props.gmatTest;
  var classes = useStyles();
  var handleChange = function handleChange(event) {
    var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var _event$target = event.target,
      eventName = _event$target.name,
      checked = _event$target.checked,
      value = _event$target.value;
    clearError(eventName, test);

    // eventName in if statements is for checkboxes
    // test in if statements is for the test scores

    // TODO: move all the constants in this file to the const file.
    var dontHaveOption = 'dont_have';
    if (eventName === dontHaveOption) {
      props.setField({
        key: Keys.Application.standardizedTests,
        value: _objectSpread(_objectSpread({}, initialState), {}, _defineProperty({}, eventName, checked))
      }); // set checkboxes

      props.setField({
        key: Keys.Application.gmatTest,
        value: {
          value: false
        }
      });
      props.setField({
        key: Keys.Application.greTest,
        value: {
          value: false
        }
      });
    } else if (eventName === 'gmat' || eventName === 'gre') {
      var _objectSpread3;
      if (eventName === 'gmat') {
        // set initial test values
        props.setField({
          key: Keys.Application.gmatTest,
          value: checked ? initialCheckedGmatState : initialUncheckedGmatState
        });
      } else if (eventName === 'gre') {
        // set initial test values
        props.setField({
          key: Keys.Application.greTest,
          value: checked ? initialCheckedGreState : initialUncheckedGreState
        });
      }

      // set checkboxes
      props.setField({
        key: Keys.Application.standardizedTests,
        value: _objectSpread(_objectSpread({}, standardizedTests), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, eventName, checked), _defineProperty(_objectSpread3, dontHaveOption, false), _objectSpread3))
      });
    } else if (test === 'GMAT') {
      props.setField({
        key: Keys.Application.gmatTest,
        value: _objectSpread(_objectSpread({}, gmatTest), {}, _defineProperty({}, eventName, value))
      });
    } else if (test === 'GRE') {
      props.setField({
        key: Keys.Application.greTest,
        value: _objectSpread(_objectSpread({}, greTest), {}, _defineProperty({}, eventName, value))
      });
    }
  };
  var gmat = standardizedTests.gmat,
    gre = standardizedTests.gre,
    dont_have = standardizedTests.dont_have;
  return /*#__PURE__*/React.createElement("div", null, error && /*#__PURE__*/React.createElement(Box, {
    className: classes.error
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    message: error
  })), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: gmat,
      onChange: handleChange,
      name: "gmat"
    }),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "GMAT")
  }), gmat && gmatTest.value && /*#__PURE__*/React.createElement(TestScores, {
    test: "GMAT",
    value: gmatTest,
    onChange: handleChange,
    error: validationError.gmat,
    showError: showError
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: gre,
      onChange: handleChange,
      name: "gre"
    }),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, "GRE")
  }), gre && greTest.value && /*#__PURE__*/React.createElement(TestScores, {
    test: "GRE",
    value: greTest,
    onChange: handleChange,
    error: validationError.gre,
    showError: showError
  })), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: dont_have,
      onChange: handleChange,
      name: "dont_have"
    }),
    label: /*#__PURE__*/React.createElement(LabelWrapper, null, VisitorStudentLanguage.Responses.dontHaveOption)
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  var _ref;
  var application = getApplication(state);
  return _ref = {}, _defineProperty(_ref, Keys.Application.greTest, application.greTest), _defineProperty(_ref, Keys.Application.gmatTest, application.gmatTest), _defineProperty(_ref, Keys.Application.standardizedTests, application.standardizedTests), _ref;
};
var connector = connect(mapStateToProps, {
  setField: setField
});
export default connector(StandardizedTests);